import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { Box, Card, CardContent, CardHeader, Grid, LinearProgress, Typography } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { useEffect, useState } from 'react';
import { DashboardService } from 'services/dashboard.service';
import { useHistory } from 'react-router-dom';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const history = useHistory()
  const getDashboardData = async () => {
    try {
      setIsLoading(true)
      const dashboard = await DashboardService.getDashboard();
      setDashboardData(dashboard)
    } catch (error) {
      
    }
    finally {
      setIsLoading(false)
    }
  
  }
  
  useEffect(()=>{
    getDashboardData();
  }, [])

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Cadastro de Tutores nos Ultimos 12 meses',
      },
    },
  };
  
  const data = {
    labels: dashboardData?.tutorData?.labels,
    datasets: [
      {
        label: 'Cadastro de Tutores',
        data: dashboardData?.tutorData?.data,
        borderColor: '#FBB45F',
        backgroundColor: '#FBB45F', maxWidth: 200,
      },

      {
        label: 'Cadastro de Empresas',
        data: dashboardData?.companyData?.data,
        borderColor: 'blue',
        backgroundColor: 'blue',
      },

      {
        label: 'Cadastro de Tutores de Empresas',
        data: dashboardData?.companyTutorData?.data,
        borderColor: 'red',
        backgroundColor: 'red',
      },
    ],
  };

  return (
    <Grid container spacing={2} justifyContent='center' alignItems='center'>
       <BreadcrumbsHeader
          items={[
            { title: 'Dashboard' },
            { title: 'Informações da Plataforma' },
          ]}
        />
      <Grid container direction='row' justifyContent='center' alignItems='center' display='flex' gap={2}>
        <Card style={{backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Tutores</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>340</Typography>
          </CardContent>
        </Card>

        <Card style={{ backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Planos de Saúde</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>35</Typography>
          </CardContent>
        </Card>

        <Card style={{ backgroundColor: '#FBB45F', width: 200, height: 100}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Atendimentos</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>126</Typography>
          </CardContent>
        </Card>

        <Card style={{ backgroundColor: '#FBB45F', width: 200, height: 100, cursor: 'pointer'}} onClick={()=>{history.push('/admin/dashboard/byPlan')}}>
          <CardContent>
            <Typography color='white' fontWeight={700} fontSize={20} align='center'>Empresas</Typography>
            <Typography color='white' fontWeight={800} fontSize={20} align='center'>9</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ width: '100%' }} hidden={!isLoading} >
          <LinearProgress />
        </Box>
        <Line style={{visibility: isLoading ? 'hidden' : 'visible'}} options={options} data={data} />;
      </Grid>
    </Grid>
  );
};
